import React from 'react';
import { Text, VStack } from '@wegroup/design-system';
import {
  InsurancePolicy,
  InsurancePolicyPackage,
} from '../../../../../../types/AdvisoryReport';
import { useTranslation } from 'react-i18next';
import InsurancePolicyPackageItem from './InsurancePolicyPackageItem';
import { Option } from '../../../../../../../../design-system/src/content/components/SearchPickerInput';
import { PartyType } from '../../../../../../../../../types/SMT';

interface Props {
  packages: InsurancePolicyPackage[];
  customRiskObjects?: Option[];
  partyType: PartyType;
  withActions?: boolean;
  partyId?: string;
  controlled?: boolean;

  // Actions
  onEdit?: (policyPackage: InsurancePolicyPackage) => void;
  onRemove?: (id: string) => void;
  onAddPolicy?: (insurancePolicy: InsurancePolicy) => void;
  onEditPolicy?: (insurancePolicy: InsurancePolicy) => void;
  onRemovePolicy?: (id: string, packageId?: string) => void;
}

const InsurancePolicyPackagesContainer: React.FC<Props> = ({
  packages,
  partyType,
  partyId,
  withActions = true,
  controlled,
  customRiskObjects,
  onEdit,
  onRemove,
  onEditPolicy,
  onRemovePolicy,
  onAddPolicy,
}) => {
  const { t } = useTranslation();

  return (
    <VStack align="stretch" spacing="4">
      <VStack align="stretch" spacing="1">
        <Text textStyle="h6Headline">
          {t('ADVISORY-REPORTS_CREATION-FLOW_INSURANCE-PACKAGES_TITLE')}
        </Text>
        <Text textStyle="smallBody" color="gray.500">
          {t('ADVISORY-REPORTS_CREATION-FLOW_INSURANCE-PACKAGES_DESCRIPTION')}
        </Text>
      </VStack>
      {packages.map((data) => (
        <InsurancePolicyPackageItem
          data={data}
          key={data.id}
          controlled={controlled}
          partyType={partyType}
          withActions={withActions}
          onEdit={onEdit}
          onRemove={onRemove}
          onEditPolicy={onEditPolicy}
          onAddPolicy={onAddPolicy}
          onRemovePolicy={onRemovePolicy}
          customRiskObjects={customRiskObjects}
          partyId={partyId}
        />
      ))}
    </VStack>
  );
};

export default InsurancePolicyPackagesContainer;
